import { browserDefaultLineHeight } from 'client/constants/editorSettings'
import { useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
import { useCalculateHeadingFontSize } from './use-calculate-heading-font-size'

export const useCalculateHeadingLineHeight = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
}) => {
  const {
    lineHeight: globalLineHeight,
    mobileLineHeight: globalMobileLineHeight,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { calculatedFontSize } = useCalculateHeadingFontSize({
    fontSize,
    mobileFontSize,
  })

  const computedLineHeight = Math.round(
    browserDefaultLineHeight * (calculatedFontSize.desktop as number),
  )

  const computedMobileLineHeight = Math.round(
    browserDefaultLineHeight * (calculatedFontSize.mobile as number),
  )

  return {
    calculatedLineHeight: getCalculatedProperty({
      desktopProperty: lineHeight,
      mobileProperty: mobileLineHeight,
      globalDesktopProperty: globalLineHeight || computedLineHeight,
      globalMobileProperty: globalMobileLineHeight || computedMobileLineHeight,
    }),
    globalLineHeight,
    globalMobileLineHeight,
  }
}
